import React, { useContext, useState, useEffect } from "react";
// import styles from "../styles/Profile/Withdraw.module.css"
import authContext from "../context/auth/authContext";
import NumberFormat from "react-number-format";
import { formatPrice } from "../helpers/format";

import dotenv from "dotenv";
import ReactTooltip from "react-tooltip";
import WithdrawModal from "../components/WithdrawModal";
import bank from "../assets/images/bank.png";
import upi from "../assets/images/upi.jpg";
import FinalWithdrawModal from "../components/FinalWithdrawModal";
import { toast } from "react-toastify";
import { useWindowSize } from "react-use";
import Message from "../components/Message";
import Swal from "sweetalert2";
import BreadCrumbs from "../components/BreadCrumbs";
import { MdDelete } from "react-icons/md";
dotenv.config();
const Withdraw = ({ history, location }) => {
  const { width } = useWindowSize();
  const {
    walletData: data,
    fetchBDetails,
    bDetails,
    fetchPendingDetails,
    pendingDetails,
    withdrawSwal,
    getAmountInWallet,
    hideWithdrawSwal,
    deleteBDetails,
  } = useContext(authContext);
  const [withdraw, setWithdraw] = useState(100);
  //doubt
  const  setCheckbox = useState(false)[1];
  const [open, setOpen] = useState(false);
  const [open1, setOpen1] = useState(false);
  const [checkbox1, setCheckbox1] = useState(false);
  const [checkbox2, setCheckbox2] = useState(false);
  const [isVpa, setIsVpa] = useState(false);
  const [details, setDetails] = useState(null);
  useEffect(() => {
    if (!data) {
      getAmountInWallet();
    }
    //eslint-disable-next-line
  }, [data]);
  useEffect(() => {
    if (location.pathname && location.pathname.split("/").includes("details")) {
      fetchPendingDetails();
    } else {
      // if (!data) {
      //   history.push("/profile");
      // } else {
      if (data) {
        setWithdraw(
          formatPrice(data.referAmt + data.contestComAmt + data.contestWinAmt)
        );
      }
      fetchBDetails();
      // }
    }
    //eslint-disable-next-line
  }, [location]);

  const handleDelete = (c, type) => {
    let d = {};

    d = {
      type: type === "bank_account" ? "bank_account" : "vpa",
      fundId: c.razorpay_fund_acc_id,
      userBankAccId: bDetails._id,
    };

    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: "TradathonRoom__join__button",
        cancelButton: "TradathonRoom__join__button",
      },
      buttonsStyling: false,
    });

    swalWithBootstrapButtons
      .fire({
        title: "Are you sure?, would you like to delete details?",
        // text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, cancel!",
        reverseButtons: true,
      })
      .then((result) => {
        if (result.isConfirmed) {
          deleteBDetails(d)
            .then((result) => {
              swalWithBootstrapButtons.fire(
                "Deleted!",
                "Your file has been deleted.",
                "success"
              );
            })
            .catch((err) => {
              toast.error(
                err.response && err.response.data.message
                  ? err.response.data.message
                  : err.message,
                { autoClose: 6000 }
              );
            });
        }
        // else if (
        //   /* Read more about handling dismissals below */
        //   result.dismiss === Swal.DismissReason.cancel
        // ) {
        //   swalWithBootstrapButtons.fire(
        //     'Cancelled',
        //     'Your imaginary file is safe :)',
        //     'error'
        //   )
        // }
      });
  };
  

  const openModal = (e) => {
    setOpen(!open);
  };
  const closeModal = (e) => {
    setOpen(false);
  };
  const openModal1 = (e) => {
    if (checkbox1 || checkbox2) {
      setOpen1(!open);
    } else {
      toast.error("Please choose an option to withdraw", { autoClose: 6000 });
    }
  };
  const closeModal1 = (e) => {
    setOpen1(false);
  };
  const routes = [
    { path: "/profile", name: "Profile" },
    { path: "/withdraw", name: "withdraw" },
    { path: "/", name: "pending withdraw details" },
  ];
  const routes1 = [
    { path: "/profile", name: "Profile" },
    { path: "/withdraw", name: "withdraw" },
  ];

  useEffect(() => {
    if (withdrawSwal && !location.pathname?.split("/")?.includes("details")) {
      closeModal1();
      Swal.fire({
        icon: "success",
        title: "Withdrawn Successful",
        text: "It would take 3 days to reflect withdrawn amount in your bank",
      }).then(() => hideWithdrawSwal());
    }
    //eslint-disable-next-line
  }, [withdrawSwal]);
  return location.pathname &&
    location.pathname.split("/").includes("details") ? (
    <>
      <div className="withdraw__container">
        <BreadCrumbs routes={routes} />
        <center>
          {pendingDetails &&pendingDetails.length>0?
            pendingDetails.map((c, index) => (
              <div
                className="Register__bank"
                style={{ width: width > 900 ? "50%" : "100%" }}
              >
                {c.bankDetails && (
                  <>
                    <img
                      src={bank}
                      alt="bank_img"
                      style={{ height: "50px", width: "50px" }}
                    />
                    <div style={{ width: "300px", overflow: "auto" }}>
                      <p>{c.bankDetails.account_number}</p>
                      <p>
                        <b>Status:</b> {c.payoutWithdrawResponse.status}
                      </p>
                    </div>
                    <div>
                      <p>
                        <NumberFormat
                          value={formatPrice(c.amount)}
                          displayType={"text"}
                          thousandSeparator={true}
                          prefix="₹"
                        />
                      </p>
                    </div>
                  </>
                )}
                {c.upiId && (
                  <>
                    <img
                      src={upi}
                      alt="upi_img"
                      style={{ height: "50px", width: "50px" }}
                    />
                    <div style={{ width: "300px", overflow: "auto" }}>
                      <p>{c.upiId.address}</p>
                      <p>
                        <b>Status:</b> {c.payoutWithdrawResponse.status}
                      </p>
                    </div>
                    <div>
                      <p>
                        <NumberFormat
                          value={formatPrice(c.amount)}
                          displayType={"text"}
                          thousandSeparator={true}
                          prefix="₹"
                        />
                      </p>
                    </div>
                  </>
                )}
              </div>
            )):<p>No details found</p>}
        </center>
      </div>
    </>
  ) : (
    data && (
      <div className="withdraw__container">
        <BreadCrumbs routes={routes1} />
        <h1 style={{ marginTop: "10px" }}>Withdraw</h1>
        {open && <WithdrawModal close={closeModal} />}
        {open1 && (
          <FinalWithdrawModal
            close={closeModal1}
            details={details}
            isVpa={isVpa}
            amount={withdraw}
          />
        )}

        <div className="withdraw__formcontainer">
          <div className="withdraw__grid">
            <div>
              <ReactTooltip place="bottom" effect="float" multiline={true} />
              <p style={{ display: "flex", alignItems: "flex-end" }}>
                Withdrawable
                {/* <span>
                  <AiFillQuestionCircle
                    size={20}
                    data-tip="What is ‘Withdrawable Balance’?<br/>It is the amount you can withdraw from Coinstorey Balance to your bank account.<br/>"
                  />
                </span> */}
              </p>
            </div>
            <div>
              <div className="withdrawAvailable">
                <NumberFormat
                  value={formatPrice(
                    data.referAmt + data.contestComAmt + data.contestWinAmt
                  )}
                  displayType={"text"}
                  thousandSeparator={true}
                  prefix="₹"
                />
              </div>
            </div>
            <div>
              <div className="withdrawAvailable">
                <p>Enter Amount</p>
              </div>
            </div>
            <div>
              <div className="withdrawAvailable">
                <input
                  type="number"
                  value={withdraw}
                  onChange={(e) => {
                    setWithdraw(e.target.value);
                    setCheckbox(false);
                  }}
                />
              </div>
            </div>
            <div style={{ gridColumn: "1/3" }}>
              <div className="withdrawAvailable">
                {data.referAmt + data.contestComAmt + data.contestWinAmt >
                  100 &&
                  (withdraw > 25000 || withdraw < 100) && (
                    <Message
                      desc="Withdraw amount cannot be less than ₹100 and more than ₹25000"
                      type="error"
                    />
                  )}
              </div>
            </div>
            {/* <div>
              <div className="withdrawAvailable">
                <input
                  type="checkbox"
                  checked={checkbox}
                  onChange={(e) => handleCheckbox(e)}
                />
                <p>Withdraw All</p>
              </div>
            </div>
           */}
            <div></div>

            {bDetails && (
              <>
                {bDetails.bankDetails &&
                  bDetails.vpaDetails &&
                  bDetails.bankDetails.length !== 0 &&
                  bDetails.vpaDetails.length !== 0 && (
                    <div className="bDetails_content">
                      <div>
                        <div>Select an option to Withdraw</div>
                      </div>
                    </div>
                  )}
                <div className="bDetails_content">
                  <section className="Register__details">
                    {bDetails.bankDetails &&
                      bDetails.bankDetails.length > 0 &&
                      bDetails.bankDetails.map((c) => (
                        <div className="Register__bank">
                          <input
                            type="checkbox"
                            checked={checkbox1}
                            onChange={(e) => {
                              setCheckbox1(e.target.checked);
                              setCheckbox2(e.target.checked && false);
                              setDetails(c);
                              setIsVpa(false);
                            }}
                          />
                          <img src={bank} alt="bank_img" />

                          <div>
                            <p>{c.bank_name}</p>
                            <p>{c.account_number}</p>
                            <p>{c.name}</p>
                          </div>

                          <MdDelete
                            size={28}
                            style={{ marginLeft: "auto", cursor: "pointer" }}
                            onClick={() => handleDelete(c, "bank_account")}
                          />
                        </div>
                      ))}

                    <div className="Register__details">
                      {bDetails.vpaDetails &&
                        bDetails.vpaDetails.length > 0 &&
                        bDetails.vpaDetails.map((c) => (
                          <div className="Register__upi">
                            <input
                              type="checkbox"
                              checked={checkbox2}
                              onChange={(e) => {
                                setCheckbox2(e.target.checked);
                                setCheckbox1(e.target.checked && false);
                                setDetails(c);
                                setIsVpa(true);
                              }}
                            />
                            <img src={upi} alt="upi_img" />
                            <div>
                              <p>{c.address}</p>
                            </div>
                            <MdDelete
                              size={28}
                              style={{ marginLeft: "auto", cursor: "pointer" }}
                              onClick={() => handleDelete(c, "vpa")}
                            />
                          </div>
                        ))}
                    </div>
                  </section>
                </div>
              </>
            )}

            {bDetails && (
              <div>
                <div
                  className="withdrawAvailable"
                  style={{ gridColumn: "1/3" }}
                >
                  <button
                    className="TradathonRoom__join__button"
                    style={{
                      // background: "rgba(69, 170, 67, 1)",
                      borderRadius: "5px",
                      background: "#8d0792",
                    }}
                    onClick={
                      !(withdraw > 25000 || withdraw < 100) && openModal1
                    }
                    disabled={withdraw > 25000 || withdraw < 100}
                  >
                    Withdraw
                  </button>
                </div>
              </div>
            )}

            <div style={{ gridColumn: "1/3" }}>
              <div className="withdrawAvailable">
                <button
                  className="TradathonRoom__join__button"
                  style={{
                    // background: "rgba(69, 170, 67, 1)",
                    borderRadius: "5px",
                    background: "#8d0792",
                  }}
                  onClick={openModal}
                >
                  Add Bank/UPI Details to withdraw
                </button>
              </div>
            </div>
            <div style={{ gridColumn: "1/3" }}>
              <div className="withdrawAvailable">
                <button
                  className="TradathonRoom__join__button"
                  style={{
                    // background: "rgba(69, 170, 67, 1)",
                    borderRadius: "5px",
                    background: "#8d0792",
                  }}
                  onClick={() => history.push("/wallet/withdraw/details")}
                >
                  View Withdraw Details
                </button>
              </div>
            </div>
          </div>
          {/* <div className="bankDetails">
         
        </div> */}
        </div>

        {/* <div className="withdrawAvailable">
           
          
          </div>
          <div className="withdrawAvailable">
          
          </div>
         */}
      </div>
    )
  );
};

export default Withdraw;
